import Flex from '@Components/Bases/Flex';
import { Box, Typography } from '@mui/material';
import GreenhouseStrategyCompleteSection from './GreenhouseStrategyCompleteSection';
import GreenhouseStrategyIntroduction, {
  GH_STRATEGY_INTRODUCTION_ID,
} from './GreenhouseStrategyIntroduction';
import GreenhouseStrategyPlan from './GreenhouseStrategyPlan';
import GreenhouseStrategyRemark, {
  GH_STRATEGY_REMARK_ID,
} from './GreenhouseStrategyRemark';

const GreenhouseStrategy = () => {
  return (
    <Box bgcolor={'white'}>
      <Box p={2}>
        <Flex gap={1} alignItems={'center'}>
          <Typography fontWeight={'bold'}>
            การกำหนดกลยุทธ์และแผนการจัดการก๊าซเรือนกระจกให้เป็นไปตามเป้าหมาย
          </Typography>
          <Flex gap={0.5} alignItems={'center'}>
            <GreenhouseStrategyIntroduction />
            <GreenhouseStrategyRemark />
          </Flex>
        </Flex>
        <Box id={GH_STRATEGY_INTRODUCTION_ID} />
        <Box id={GH_STRATEGY_REMARK_ID} />
        <GreenhouseStrategyPlan />
      </Box>
      <GreenhouseStrategyCompleteSection />
    </Box>
  );
};

export default GreenhouseStrategy;
